<template>
	<nav class="bottom-nav">
		<!-- <button
			v-if="!isLoggedIn && route.name !== 'PromoPage' && route.name !== 'MobileLogin'"
			@click="triggerLogin"
			class="btn red"
		>
			<span>{{ $t("profile.loginnow") }}</span>
		</button> -->

		<router-link to="/home" class="nav-item" v-focus>
			<IconHome />
			<span>{{ $t("header.frontpage") }}</span>
		</router-link>

		<router-link to="/movies" class="nav-item" v-focus>
			<IconMovies />
			<span>{{ $t("header.movies") }}</span>
		</router-link>

		<router-link to="/series" class="nav-item" v-focus>
			<IconSeries />
			<span>{{ $t("header.series") }}</span>
		</router-link>

		<!-- <router-link to="/search" class="nav-item" v-focus>
			<IconSearch />
			<span>Search</span>
		</router-link> -->

		<router-link v-if="isLoggedIn" to="/profile" class="nav-item" v-focus>
			<IconProfile />
			<span>{{ $t("profile.title") }}</span>
		</router-link>
		<div v-else @click="triggerLogin" class="nav-item" v-focus>
			<IconProfile />
			<span>{{ $t("profile.login_basic") }}</span>
		</div>
	</nav>
</template>

<script setup lang="ts">
	import { computed } from "vue"
	import { useUserStore } from "../stores/user"
	import { useRoute } from "vue-router"
	import IconSearch from "../icons/IconSearch.vue"
	import { useLogin } from "../composables/useLogin"
	import IconHome from "../icons/IconHome.vue"
	import IconMovies from "../icons/IconMovie.vue"
	import IconSeries from "../icons/IconSeries.vue"
	import IconProfile from "../icons/IconUser.vue"
	const route = useRoute()

	// Placeholder icon components - replace with your actual icons
	// const IconHome = {
	// 	template:
	// 		'<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>',
	// }
	// const IconMovies = {
	// 	template:
	// 		'<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="7" width="20" height="15" rx="2" ry="2"/><polyline points="17 2 12 7 7 2"/></svg>',
	// }
	// const IconSeries = {
	// 	template:
	// 		'<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="2" width="20" height="20" rx="2.18" ry="2.18"/><line x1="7" y1="2" x2="7" y2="22"/><line x1="17" y1="2" x2="17" y2="22"/><line x1="2" y1="12" x2="22" y2="12"/></svg>',
	// }
	// const IconProfile = {
	// 	template:
	// 		'<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>',
	// }

	const userStore = useUserStore()
	const { login } = useLogin()

	const isLoggedIn = computed(() => userStore.state.isLoggedIn)

	const triggerLogin = async () => {
		sessionStorage.setItem("post_auth_redirect", "/profile")
		await login()
	}
</script>

<style lang="scss" scoped>
	.bottom-nav {
		position: fixed;
		bottom: 0;
		left: 0;
		right: 0;
		display: flex;
		justify-content: space-around;
		align-items: center;
		background: rgba(0, 0, 0, 0.705);
		backdrop-filter: blur(10px);
		border-top: 1px solid rgba(255, 255, 255, 0.1);
		padding: 8px 0;
		z-index: 1000;

		// Add safe area padding for iOS/Android
		padding-bottom: calc(8px + var(--safe-area-inset-bottom, 0px));

		.nav-item {
			display: flex;
			flex-direction: column;
			align-items: center;
			gap: 4px;
			padding: 8px 16px;
			text-decoration: none;
			color: rgba(255, 255, 255, 0.6);
			transition: all 0.2s ease;
			border-radius: 12px;
			min-width: 60px;
			cursor: pointer;

			svg {
				width: 24px;
				height: 24px;
			}

			span {
				font-size: 11px;
				font-weight: 500;
			}

			&:hover,
			&:focus,
			&.router-link-active {
				color: white;
				background: rgba(255, 255, 255, 0.1);
			}

			&.router-link-active {
				color: #e50914; // Netflix red or your brand color
			}
		}

		// Hide on larger screens (desktop)
		// @media (min-width: 768px) {
		// 	display: none;
		// }
	}

	// Add bottom padding to page content to prevent overlap
	:global(body.is-ios .page-content),
	:global(body.is-android .page-content) {
		padding-bottom: calc(70px + var(--safe-area-inset-bottom, 0px));
	}

	.btn {
		font-size: 20px;
		width: 60%;
		padding: 10px 20px;
		margin: 20px auto 10px auto;
	}
</style>
